var map = {
	"./decidim/avatar-multiuser.png": 67455,
	"./decidim/brands/facebook.svg": 31903,
	"./decidim/brands/google.svg": 79782,
	"./decidim/brands/twitter-x.svg": 14351,
	"./decidim/cc-badge.png": 72789,
	"./decidim/decidim-logo.svg": 31469,
	"./decidim/default-avatar.svg": 59229,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 72451,
	"./decidim/icons.svg": 5164,
	"./decidim/pattern.png": 37231,
	"./decidim/placeholder-card-g.svg": 63028,
	"./decidim/placeholder-card-l.svg": 88655,
	"./decidim/placeholder.jpg": 51702,
	"./decidim/remixicon.symbol.svg": 14652,
	"./decidim/vendor/social-share-button/douban.svg": 90319,
	"./decidim/vendor/social-share-button/email.svg": 66104,
	"./decidim/vendor/social-share-button/facebook.svg": 78404,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 15824,
	"./decidim/vendor/social-share-button/hacker_news.svg": 44604,
	"./decidim/vendor/social-share-button/linkedin.svg": 31358,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 31991,
	"./decidim/vendor/social-share-button/pinterest.svg": 88822,
	"./decidim/vendor/social-share-button/reddit.svg": 53196,
	"./decidim/vendor/social-share-button/telegram.svg": 34721,
	"./decidim/vendor/social-share-button/tumblr.svg": 91614,
	"./decidim/vendor/social-share-button/twitter.svg": 16085,
	"./decidim/vendor/social-share-button/vkontakte.svg": 72039,
	"./decidim/vendor/social-share-button/wechat.svg": 99922,
	"./decidim/vendor/social-share-button/whatsapp.svg": 47378,
	"./decidim/vendor/social-share-button/x.svg": 86936,
	"./decidim/vendor/social-share-button/xing.svg": 55376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61272;